import { render, staticRenderFns } from "./GroupInvitationPanel.vue?vue&type=template&id=0ae34458&scoped=true&"
import script from "./GroupInvitationPanel.vue?vue&type=script&lang=js&"
export * from "./GroupInvitationPanel.vue?vue&type=script&lang=js&"
import style0 from "./GroupInvitationPanel.vue?vue&type=style&index=0&id=0ae34458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae34458",
  null
  
)

export default component.exports